import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {JhiEventManager} from 'ng-jhipster';
import {IActivityObject} from '@entities/activity/activity.model';
import {ActivityService} from '@entities/activity/activity.service';

@Component({
  selector: 'app-activity-object-delete-dialog',
  templateUrl: './activity-type-delete-object-dialog.component.html',
})
export class ActivityDeleteObjectDialogComponent {
  activityObject: IActivityObject;

  @HostListener('window:keyup.esc')
  private onKeyUp() {
    this.dialogRef.close();
  }

  constructor(
    private dialogRef: MatDialogRef<ActivityDeleteObjectDialogComponent>,
    private activityTypeService: ActivityService,
    private eventManager: JhiEventManager,
  ) {}

  confirmDelete(activityTypeId) {
    this.activityTypeService
      .deleteActivityObject(activityTypeId)
      .subscribe((response) => {
        this.eventManager.broadcast({
          name: 'activityObjectListModification',
          content: 'Deleted an activity object',
        });
        this.dialogRef.close(true);
      });
  }
}

@Component({
  selector: 'app-activity-object-delete-popup',
  template: '',
})
export class ActivityDeleteObjectPopupComponent implements OnInit, OnDestroy {
  private dialogRef: MatDialogRef<ActivityDeleteObjectDialogComponent>;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private titleService: Title,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(
      this.translate.instant('entities.activity.activityTypeObject.delete'),
    );
    this.activatedRoute.data.subscribe(({activityObject}: Data) => {
      setTimeout(() => {
        this.dialogRef = this.dialog.open(ActivityDeleteObjectDialogComponent, {
          disableClose: true,
          width: '380px',
        });

        this.dialogRef.componentInstance.activityObject = activityObject;

        this.dialogRef.afterClosed().subscribe(
          (result) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
          (reason) => {
            this.router.navigate([{outlets: {popup: null}}], {
              replaceUrl: true,
              queryParamsHandling: 'merge',
            });
          },
        );
      }, 0);
    });
  }

  ngOnDestroy() {
    this.titleService.setTitle(
      this.translate.instant('entities.activity.activityType.detail'),
    );
    this.dialogRef = null;
  }
}
